import React from 'react'
import PropTypes from 'prop-types'
import Spinner from '../../Spinner/Spinner'
import { ComponentItemType } from '../../../utility/prop-types.js'
import { observer } from 'mobx-react'
export const REG_EXP = /{{\s*[\w.]+\s*}}/g
export const CLEAN_REG_EXP = /[\w.]+/

const HtmlEditor = observer(class HtmlEditor extends React.Component {
  static propTypes = {
    item: ComponentItemType,
    children: PropTypes.arrayOf(PropTypes.node)
  }

  constructor (props) {
    super(props)
    this.state = {
      html: (props.props && props.props.html) || ``
    }
  }

  static getDerivedStateFromProps (props, state) {
    if (!!props.props && (props.props.html !== state.html)) {
      return { html: props.props.html }
    }
    return null
  }

  updateMapping = (key, value) => {
    const { item } = this.props
    let mapping = item && item.mapping && item.mapping.children.find(child => child.key === key)
    if (mapping) {
      mapping.update({
        value,
        bindingType: 'value'
      })
    }
  }

  handleEditorStateChange = ({ html }) => {
    this.updateMapping('html', html)
    this.setState({ html })
  }

  render () {
    const { html } = this.state

    let isLoading = false

    if (this.props && this.props.props) {
      isLoading = this.props.props.isLoading
    }
    const loadingStyle = isLoading ? { height: '100%', display: 'flex', justifyContent: 'center' } : {}

    if (isLoading) return (<div style={loadingStyle}><Spinner isVisible={isLoading} size='small' /></div>)

    return (
      <div dangerouslySetInnerHTML={{ __html: html }} />
    )
  }
})

export default HtmlEditor
